import { createSSRApp } from 'vue';
import App from './App.vue';
import i18n from './locale/index';

// #ifdef MP
import { mpShareMixin } from './mixins/mpShare';
// #endif
import { routeInterceptor } from './router/interceptor';
import store from './store';
// import 'virtual:uno.css';

// H5端：错误日志采集
// #ifdef H5
import { initErrorHandler } from './utils/logReporter';
// #endif

// 百度移动统计小程序 SDK - 初始化并挂载 wx.mtj API
// ⚠️ 已临时关闭：小程序主包体积超限，暂不打包百度统计 SDK（mtj-wx-sdk.js）。
//    H5 端不受影响，恢复方法详见 docs/baidu-analytics-guide.md（取消下面 import 注释即可）。
// #ifdef MP-WEIXIN
// import './utils/analytics/mtj-wx-sdk.js';
// #endif

export function createApp() {
  const app = createSSRApp(App);
  app.use(store);
  app.use(routeInterceptor);
  app.use(i18n);

  // 小程序全局分享：默认分享首页，商品详情/档口详情系列页面按规则分享对应详情页
  // #ifdef MP
  app.mixin(mpShareMixin);
  // #endif

  // H5端：初始化错误日志采集
  // #ifdef H5
  initErrorHandler(app);
  // #endif

  return {
    app,
  };
}
